import { InputText } from "primereact/inputtext";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

const P002InputText = (props) => {
  const {
    label,
    name,
    formik,
    rootCol,
    rootLgCol,
    inputCol,
    inputLgCol,
    required,
    iconClassName,
  } = props;

  return (
    <div
      className={`${rootCol ? `col-${rootCol} p-0` : ""} ${
        rootLgCol ? `lg:col-${rootLgCol}` : ""
      } `}
    >
      <div
        className={`${inputCol ? "col-" + inputCol : ""} 
        ${inputLgCol ? `lg:col-${inputLgCol}` : ""} 
        flex flex-column`}
      >
        <label className="pb-1">
          {required && <span className="text-red-600">* </span>}
          {label}
        </label>
        {iconClassName ? (
          <IconField iconPosition="left">
            <InputIcon className={iconClassName}></InputIcon>
            <InputText
              pt={{ root: { className: "w-full" } }}
              name={name}
              value={formik.values[name]}
              onChange={formik.handleChange}
              invalid={formik.errors[name]}
            />
          </IconField>
        ) : (
          <InputText
            name={name}
            value={formik.values[name]}
            onChange={formik.handleChange}
            invalid={formik.errors[name]}
          />
        )}
        {formik.errors[name] && (
          <small className="p-error">{formik.errors[name]}</small>
        )}
      </div>
    </div>
  );
};

export default P002InputText;
